import React from 'react'
import {StyledMainContainer, StyledChartContainer} from './style'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'

export const DashboardOperationalAccessesPerformanceChartSkeleton: React.FC = () => {
    return (
        <StyledMainContainer direction="column" gap={4} fullWidth>
            {/* Chart */}
            <StyledChartContainer>
                <Skeleton width="100%" height="100%" />
            </StyledChartContainer>
        </StyledMainContainer>
    )
}
